import { createContext, useContext } from "react";

export const CollectionContext = createContext(null);

export const useCollectionActions = () => useContext(CollectionContext);
